import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IYearMonth } from '@/coreDomainsModule/date';
import { BulkUpdateAdapter } from '../adapter/bulkUpdateAdapter';
import { SupplierForecastRepository } from '@/coreInfrastructureModule/Repositories/SupplierForecastRepository';

/**
 * 仕入先内示を一括で更新するUseCase
 */
export class BulkUpdateSupplierForecastUseCase {
  /**
   * 仕入先内示を更新する
   * @param repository - リポジトリ
   * @param aggregateBusinessIds - 対象の集計ID
   * @param staffIds - 担当者IDリスト
   */
  public async Execute(
    repository: SupplierForecastRepository,
    aggregateBusinessIds: string[],
    staffIds: string[]
  ): Promise<INetworkResult<void, Error>> {
    try {
      const request = BulkUpdateAdapter.adaptForRequest(aggregateBusinessIds, staffIds);
      const response = await repository.updateResponsibleUserId(request);
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          throw response.status.error;
        default:
          throw new Error('Invalid status');
      }
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('編集に失敗しました。再度編集してください。'),
        },
      };
    }
  }
}
